import axios from "axios";
import { generateDynamicSignature } from "./generateDynamicSignature";
import BASE_URL from "../constants/baseURL";

const apiClient = axios.create({
  baseURL: BASE_URL.adn_api.url + BASE_URL.adn_api.version,
  timeout: 15000,
});

export async function apiRequest({
  url,
  method = "GET",
  data = null,
  params = null,
  headers = {},
  authToken = "",
}) {
  const { signature, timestamp, nonce } = await generateDynamicSignature(data);

  const response = await apiClient({
    url,
    method,
    data,
    params,
    headers: {
      ...headers,
      ...(authToken && {
        Authorization: authToken,
      }),

      "x-signature": signature,
      "x-timestamp": timestamp,
      "x-nonce": nonce,
    },
  });

  return response;
}
